import { StrictMode } from 'react'
import { App } from '@/components/app'

export const Root = () => (
  <StrictMode>
    <App />
  </StrictMode>
)
